/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

import {Component, Input, Output, ChangeDetectionStrategy} from '@angular/core';
import {Subject} from 'rxjs';

@Component({
    selector: 'app-part-number-changes-dialog-button',
    templateUrl: './part-number-changes-dialog-button.component.html',
    styleUrls: ['./part-number-changes-dialog-button.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})

export class PartNumberChangesDialogButtonComponent {
    @Output() toggleDialog = new Subject<void>();
    @Input() isDialogOpen: boolean;
    @Input() dialogButtonTitle: string;
    @Input() dialogButtonDirection: string;

    get toggleButtonClass(): string {
        let base = 'pnc-dialog-history-toggle-button';
        if (this.isDialogOpen) {
            base = base + ' active';
        }
        return base;
    }

    get toggleButtonArrowClass(): string {
        const base = 'toggle-button-arrow';
        return `${base} ${this.isDialogOpen ? 'iwp-icon-gen_arrow_down active' : 'iwp-icon-gen_arrow_right'}`;
    }

    handleDialogClick(): void {
        this.toggleDialog.next();
    }
}
